import Rails from '../src/js/vendor/ujs';
import { initToggleActive } from '../src/js/toggle-active';
import enableTippy from '../src/js/enable-tippy';
import selectAutoRedirect from '../src/js/select-auto-redirect';
import initCookieBanner from '../src/js/cookie-banner';
Rails.start();
initToggleActive();
selectAutoRedirect();
enableTippy();
initCookieBanner();
